import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from "./login-component/Login";
import Booking from "./booking/Booking";
import VehicleRateLookup from "./booking/VehicleRateLookup";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/vehicle-rates" element={<VehicleRateLookup />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
